import { timeout } from '@/src/compat/util';

import { ApiManagerListMock } from './ApiManagerService.mocks';
import { IApiManagerService } from './IApiManagerService';

import { IApiManagerResponse } from '@/modules/ApiManagerModule/interfaces/apiManager';

export class StubApiManagerService implements IApiManagerService {
  static create(): IApiManagerService {
    return new StubApiManagerService();
  }

  /**
   * @desc Get all api tokens by account
   * @returns {Promise<IApiManagerResponse>}
   */
  async getApiTokens(): Promise<IApiManagerResponse> {
    try {
      await timeout(2000);
      return { tokens: ApiManagerListMock, limit: 10 };
    } catch (error) {
      return { tokens: [], limit: 10 };
    }
  }

  /**
   * @desc Generate a new API key for a client
   * @param {string} name
   * @returns {Promise<boolean>}
   */
  async creteApiTokens(name: string): Promise<boolean> {
    try {
      await timeout(2000);
      return true;
    } catch (error) {
      return false;
    }
  }
}
